import React from 'react'
import styled from 'styled-components'

import Colors from '../../commons/Colors'
import { numberFormat } from '../../commons/NumberUtils'

/**
 * Conteúdo da expansão da linha: os produtos do pedido.
 *
 * O pedido continua sendo uma única linha na grade e um único registro nos
 * totalizadores — a expansão é só apresentação.
 */
export default function OrderItemsExpansion({ order }) {
    return (
        <Container data-testid={`order-items-${order.orderId}`}>
            <ItemsTable>
                <thead>
                    <tr>
                        <th>Produto</th>
                        <th>Peso (ton)</th>
                        <th>Classificação</th>
                    </tr>
                </thead>
                <tbody>
                    {(order.items || []).map((item, index) => (
                        <tr key={`${order.orderId}-${item.productId}-${index}`}>
                            <td>{item.productName}</td>
                            <td>{numberFormat(item.weightInTonnes ?? 0, 2)}</td>
                            <td>{item.classificationName || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </ItemsTable>
        </Container>
    )
}

const Container = styled.div`
    padding: 12px 24px;
    background-color: ${Colors.whiteGray};
`

const ItemsTable = styled.table`
    width: 100%;
    border-collapse: collapse;

    th {
        text-align: left;
        font-family: Roboto;
        font-size: 12px;
        font-weight: bold;
        color: ${Colors.brownishGrey};
        padding: 6px 8px;
    }

    td {
        font-family: Roboto;
        font-size: 13px;
        color: ${Colors.black};
        padding: 6px 8px;
        border-top: solid 1px ${Colors.lightBlueGreyFour};
    }
`
